import {connect} from 'react-redux';
import ContractListing from "./ContractList";
import {bindActionCreators} from 'redux';
import {getContractList} from "../../../services/redux/ContractAssetsMapping/action";

const mapStateToProps = (state) => ({
    contractList: state.contractAssetsMapping.contractList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getContractList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractListing);
